import React, { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

const FileUpload = (props) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState('');
  const [filename, setFilename] = useState('Choose File To Upload');

  const onChange = e => {
    if (props.callback) {
      props.callback(e.target.files[0]);
    }
    if (props.type && props.type.indexOf(e.target.files[0].type) < 0) {
      // alert("Sorry, upload file type isn't " + props.type);
    }
    else{
    setFile(e.target.files[0]);
    setFilename(e.target.files[0].name);
    }
  };

  // this has nothing to do with onSubmit function
  const onSubmit = async e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', file);
    formData.append('specificType', props.type);
    formData.append('networkZone', props?.networkZone ?? 0);
    if (props.type && props.type.indexOf(file.type) < 0) {
      alert("Sorry, upload file type isn't " + props.type);
    }
    else {
      if(props.nonDispatch){
        props.doAction(formData, props.token)
      } else {
        dispatch(props.doAction(formData, props.token));
      }
    }
  };

  return (
    <Fragment>
      <form className='upload-form'>
        <div className='custom-file'>
          <input type='file' accept={props.type} className='custom-file-input' id='customFile' onChange={onChange} />
          <label className='custom-file-label' htmlFor='customFile'>
            {filename}
          </label>
        </div>
        <input type='button' value='Upload' className='btn btn-primary btn-block upload-btn' onClick={onSubmit}
        />
      </form>
      {file ? (
        <div className='row mt-5 display-file-name'>
          <div className='col-md-6 m-auto'>
            <h3 className='text-center'>{file.name}</h3>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

export default withRouter(FileUpload);
